import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import * as TrendUI from '@root/entities/trend/ui'
import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { MarkerCapShortFormatted } from '@root/shared/core/format'

import { ExploreTwoRowsTextCell } from './explore-two-rows-text-cell'

import type { PairMetrics, PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
  period: PairMetrics.MetricsSpan
}

export const ExploreTableMcCell: React.FC<Props> = ({ pair, period }) => {
  const [marketCapUsd] = useAtom(pair.marketCapUsd)
  const [priceChange] = useAtom(pair.stats[period].priceChange)
  const priceChangeTrend = Trend.of(priceChange)

  return (
    <ExploreTwoRowsTextCell
      gap={2}
      firstRow={
        <Trend_>
          <TrendUI.TrendTriangle trend={priceChangeTrend} size={10} />

          <FlashTextContentDistinct>
            <MarkerCapShortFormatted mcap={marketCapUsd} />
          </FlashTextContentDistinct>
        </Trend_>
      }
      secondRow={
        <Price $trend={priceChangeTrend}>
          <FlashTextContentDistinct>
            <Numeric value={priceChange} forceSign preset="percents" />%
          </FlashTextContentDistinct>
        </Price>
      }
    />
  )
}

const Price = styled.span<{ $trend: Trend.Trend }>`
  color: ${({ $trend }) =>
    $trend === Trend.Neutral
      ? 'var(--text-8)'
      : TrendUI.colorCSSVar($trend, { mode: 'candle' })};

  font-weight: 600;
  line-height: normal;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const Trend_ = styled.div`
  display: flex;
  align-items: center;
`
